import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./index.css";
import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import { useDocTitle } from "./components/CustomHook";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import AssistantEngineer from "./pages/AssistantEngineer";
import PoliceConstable from "./pages/PoliceConstable";
import SubInspector from "./pages/SubInspector";
import NavBar from "./components/Navbar/NavBar";
import Footer from "./components/Footer";
import ComputerCourse from "./pages/ComputerCourse";
import Communication from "./pages/Communicaion";
import Counselling from "./pages/Counselling";
import Placement from "./pages/Placement";
import Project from "./pages/Project";
import AdminDashboard from "./pages/AdminDashboard";
import Intro from "./components/Intro";
import UserDashboard from "./pages/UserDashboard";
import { AuthProvider } from "./contexts/AuthContext";
import { useAuth } from "./contexts/AuthContext";
import "./App.css";
import KnowMyCollege from "./pages/KnowMyCollege";

function App() {
  useEffect(() => {
    const aos_init = () => {
      AOS.init({
        once: true,
        duration: 1000,
        easing: "ease-out-cubic",
      });
    };

    window.addEventListener("load", aos_init);
    return () => window.removeEventListener("load", aos_init);
  }, []);

  useDocTitle("Yaazhtech Education");

  const MainLayout = () => {
    return (
      <div className="flex flex-col min-h-screen">
        <NavBar />
        <div className="flex-grow">
          <Outlet />
        </div>
        <Footer />
      </div>
    );
  };

  const DashboardLayout = ({ children }) => {
    return (
      <div className="flex flex-col min-h-screen">
        <NavBar />
        <div className="flex-grow">
          {children}
        </div>
      </div>
    );
  };

  const ProtectedRoute = ({ children }) => {
    const { isLoggedIn } = useAuth();
    return isLoggedIn ? children : <Navigate to="/login" replace />;
  };

  const AdminRoute = ({ children }) => {
    const { isLoggedIn, role } = useAuth();
    return isLoggedIn && role === "ADMIN" ? children : <Navigate to="/login" replace />;
  };

  const UserRoute = ({ children }) => {
    const { isLoggedIn, role } = useAuth();
    return isLoggedIn && role === "PUPIL" ? children : <Navigate to="/login" replace />;
  };

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="home" element={<Home />} />
          <Route path="about" element={<Intro />} />
          <Route path="contact" element={<Contact />} />
          <Route path="signup" element={<SignUp />} />
          <Route path="login" element={<SignIn />} />
          <Route path="assistantEngineer" element={<AssistantEngineer />} />
          <Route path="policeConstable" element={<PoliceConstable />} />
          <Route path="subInspector" element={<SubInspector />} />
          <Route path="computerCourse" element={<ComputerCourse />} />
          <Route path="communication" element={<Communication />} />
          <Route path="counselling" element={<Counselling />} />
          <Route path="placement" element={<Placement />} />
          <Route path="project" element={<Project />} />
          
          {/* Protected routes */}
          <Route path="know-my-college" element={
            <ProtectedRoute>
              <KnowMyCollege />
            </ProtectedRoute>
          } />
        </Route>

        {/* Dashboard routes */}
        <Route path="userDashboard" element={
          <UserRoute>
            <DashboardLayout>
              <UserDashboard />
            </DashboardLayout>
          </UserRoute>
        } />

        <Route path="adminDashboard" element={
          <AdminRoute>
            <DashboardLayout>
              <AdminDashboard />
            </DashboardLayout>
          </AdminRoute>
        } />

        {/* Catch-all route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    )
  );

  return (
    <div className="font-bodyFont">
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </div>
  );
}

export default App;